import { Box, Card, Grid } from '@mui/material'
import { useEffect, useState } from 'react'
import { useGetUserStorageCustomers } from 'src/api/customer'
import { CenteredSpinner } from 'src/components/Spinner'
import NewsFeed from 'src/components/news/NewsFeed'
import UserAllStorages from 'src/containers/storage/UserAllStorages'
import { useViewportHeight } from 'src/hooks/useViewportHeight'
import {
  BarChartComponent,
  ChartContainer,
  chartSetting,
  CustomerContribution,
  dataset,
  OperationSummary,
  valueFormatter,
} from 'src/screens/serviceStations/ServiceStationMainPage'

const StorageMainPage = () => {
  const [open, setOpen] = useState(0)
  const { data, isLoading } = useGetUserStorageCustomers()
  const viewportHeight = useViewportHeight()

  const totalChartHeight = ((viewportHeight - 180) * 2) / 3
  const chartComponentHeight = Math.max(120, totalChartHeight / 2.3)
  const operationSummaryWidth = Math.max(200, Math.min(350, chartComponentHeight * 1.5))

  useEffect(() => {
    const currentCustomerId = localStorage.getItem('currentCustomerId')
    const customer = data?.find(c => c.id.toString() === currentCustomerId)
    if (currentCustomerId) {
      setOpen(parseInt(currentCustomerId))
      if (customer?.isAdminCustomer) localStorage.setItem('selectedCustomerAdminCustomerId', currentCustomerId)
    } else if (data && data?.length > 0) {
      setOpen(data[0]?.id)
      if (data[0]?.isAdminCustomer) localStorage.setItem('selectedCustomerAdminCustomerId', data[0]?.id.toString())
    }
  }, [data])

  return (
    <Box className="relative z-10 h-full overflow-hidden w-full" sx={{ width: '100%', backgroundColor: '#F1F5F7' }}>
      <Box className="pt-1">
        <Grid container>
          <Grid item md={7} lg={7} sm={12}>
            {isLoading ? <CenteredSpinner /> : <UserAllStorages customers={data} open={open} setOpen={setOpen} />}
          </Grid>
          <Grid item md={5} lg={5} sm={12} className="pl-16-core">
            <ChartContainer height={totalChartHeight}>
              <Grid container>
                <Grid item md={6} lg={6} sm={12}>
                  <OperationSummary width={operationSummaryWidth} height={chartComponentHeight} />
                </Grid>
                <Grid
                  item
                  md={6}
                  lg={6}
                  sm={12}
                  sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                >
                  <CustomerContribution height={chartComponentHeight} />
                </Grid>
                <Grid
                  item
                  md={12}
                  lg={12}
                  sm={12}
                  sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                >
                  <BarChartComponent
                    dataset={dataset}
                    chartSetting={chartSetting}
                    valueFormatter={valueFormatter}
                    height={chartComponentHeight}
                  />
                </Grid>
              </Grid>
            </ChartContainer>
            <Box className="pt-16-core">
              <Card
                className="p-4-core scrollbar"
                sx={{
                  height: ((window.innerHeight - 112) * 1) / 3 - 22,
                  boxShadow: 'none',
                  border: 'none',
                  overflowY: 'auto',
                }}
              >
                {open ? (
                  <NewsFeed
                    customerId={open}
                    isCustomerAdmin={data?.find(c => c.id === open)?.isAdminCustomer}
                    hasLocalities={false}
                    hasServiceStations={false}
                    hasStorages={data?.find(c => c.id === open)?.hasStorages}
                  />
                ) : null}
              </Card>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  )
}

export default StorageMainPage
